import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GeneralService } from '../services/general.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private _generalService: GeneralService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Opcionalmente, añadir el token a todas las peticiones
    const token = localStorage.getItem('token');
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Si el servidor devuelve un 401 o 403, significa que el usuario no está autorizado
        if (error.status === 401 || error.status === 403) {
          console.log('Token inválido o sin autorización, cerrando sesión...');
          this._generalService.logout();
        }
        return throwError(error);
      })
    );
  }
}